import styles from 'css/src/components/app/template-preview/TemplatePickerModal.module.scss';

import React, { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { type Template } from 'js/src/client';
import TemplateCategorySelectionList from 'js/src/components/app/template-preview/TemplateCategorySelectionList';
import Modal, { MODAL_SIZES } from 'js/src/components/common/ui/modal';
import type { TemplatePickerModalContext } from 'js/src/data/modals';
import { getModalContext, hideModal, isTemplatePickerModalShowing } from 'js/src/data/modals';
import { loadTemplatesAndCategories } from 'js/src/data/templates';
import type { ImmutableMap } from 'js/src/libs/consts';
import { useAppDispatch } from 'js/src/libs/RootState';

const TemplatePickerModal = () => {
    const dispatch = useAppDispatch();

    const isShowing = useSelector(isTemplatePickerModalShowing);
    const modalContext = useSelector(getModalContext<TemplatePickerModalContext>);
    const onSelect = modalContext?.toJS().onSelect;

    const closeModal = useCallback(() => {
        dispatch(hideModal());
    }, [dispatch]);

    const handleSelect = useCallback(
        (template: ImmutableMap<Template>) => {
            if (onSelect) {
                onSelect(template);
            }
            dispatch(hideModal());
        },
        [dispatch, onSelect],
    );

    const onHide = useCallback(() => {
        closeModal();
    }, [closeModal]);

    useEffect(() => {
        if (isShowing) {
            dispatch(loadTemplatesAndCategories());
        }
    }, [dispatch, isShowing]);

    return (
        <Modal
            showing={isShowing}
            onHidden={onHide}
            size={MODAL_SIZES.XL}
            title="Select a template"
            className={styles['template-picker-modal']}
            noPadding={true}
        >
            <TemplateCategorySelectionList
                onTemplateClick={handleSelect}
                hidePreviewButton={true}
            />
        </Modal>
    );
};

export default TemplatePickerModal;
